export default function Testimonial() {
  return (
    <section className="py-12 md:py-20 bg-[#0a0a0a] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, rgba(220, 38, 38, 0.3) 1px, transparent 1px)',
          backgroundSize: '30px 30px'
        }}></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center">
          <i className="ri-double-quotes-l text-4xl sm:text-5xl md:text-6xl text-[#dc2626] mb-6 inline-block"></i>

          <blockquote className="text-base sm:text-xl md:text-3xl font-light text-white leading-relaxed mb-6 italic px-2">
            I don't recommend an attorney unless I use them myself. Mark Kohler and his team built my entity structure, my tax plan, and my estate plan — all under one roof. This is the only firm I send my people to.
          </blockquote>

          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full overflow-hidden bg-[#1a1a1a] border-2 border-[#dc2626] flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/93c3e079cd1f297eadf6098c3b0ef55d/dadaf59f289a861c44051d9874a96e48.jpeg"
                alt="Matt Theriault"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="text-left">
              <p className="text-base sm:text-lg font-bold text-white">Matt Theriault</p>
              <p className="text-xs sm:text-sm text-gray-400">Host of Epic Real Estate Investing</p>
              <p className="text-xs text-[#dc2626] font-semibold">(1M+ Monthly Views)</p>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-4 sm:gap-8 pt-6 border-t border-[#2a2a2a]">
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-[#dc2626] text-lg sm:text-xl"></i>
              <span className="text-xs sm:text-sm text-gray-400 font-medium">Trusted by 10,000+ Clients</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-map-pin-line text-[#dc2626] text-lg sm:text-xl"></i>
              <span className="text-xs sm:text-sm text-gray-400 font-medium">Offices in AZ, UT, ID</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-award-line text-[#dc2626] text-lg sm:text-xl"></i>
              <span className="text-xs sm:text-sm text-gray-400 font-medium">25+ Years Experience</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
